import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6 3a1 1 0 0 0 0 2v1.4C6 9.156 8 12 11 12c-2.51 0-4.32 1.838-4.844 5A12 12 0 0 0 6 19a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2 9.3 9.3 0 0 0-.22-2c-.598-2.696-2.365-5-4.78-5 3 0 5-2.1 5-5.6V5a1 1 0 1 0 0-2zm2.19 14c.18-.86.47-1.508.802-1.964C9.501 14.337 10.156 14 11 14h2c.623 0 1.323.355 1.958 1.313.318.48.578 1.058.759 1.687zM8 5h8v2H8z",
      clipRule: "evenodd"
    }
  )
);
var SvgSandclockFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SandclockFilled_default = SvgSandclockFilled;

export { SandclockFilled_default as default };
